/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_OnairInputs */

const en_fw_node_onair = /** @type {(inputs: Fw_Node_OnairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On air`)
};

const zh_fw_node_onair = /** @type {(inputs: Fw_Node_OnairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播出`)
};

/**
* | output |
* | --- |
* | "On air" |
*
* @param {Fw_Node_OnairInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_onair = /** @type {((inputs?: Fw_Node_OnairInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_OnairInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_onair(inputs)
	return zh_fw_node_onair(inputs)
});
export { fw_node_onair as "fw.node.onair" }